export const createClientCommandRequestGate = () => {
  let generation = 0;
  let activeScopeKey = null;
  let controller = null;

  const begin = (scopeKey) => {
    if (typeof scopeKey !== 'string' || !scopeKey.trim()) {
      throw new Error('A Client Command request scope key is required.');
    }

    controller?.abort();
    controller = new AbortController();
    activeScopeKey = scopeKey.trim();
    generation += 1;

    return {
      scopeKey: activeScopeKey,
      generation,
      signal: controller.signal,
    };
  };

  const isCurrent = (request) => (
    !!request
    && !request.signal?.aborted
    && request.generation === generation
    && request.scopeKey === activeScopeKey
  );

  const accept = (request, value) => (
    isCurrent(request)
      ? { accepted: true, value }
      : { accepted: false, value: undefined }
  );

  const cancel = () => {
    controller?.abort();
    controller = null;
    activeScopeKey = null;
    generation += 1;
  };

  return {
    begin,
    isCurrent,
    accept,
    cancel,
  };
};
